import axiosRequest from './axios.js'

export default {
  // 查询个体/实体任务总条数
  queryTaskNum (params) {
    return axiosRequest.post('/task/queryTaskNum', params)
  },
  // 个体/实体批量查询列表
  queryDetail (params) {
    return axiosRequest.post('/task/queryDetail', params)
  },
  // 删除个体/实体批量任务
  deleteTask (params) {
    return axiosRequest.post('/task/deleteTask', params)
  },
  // 导出个体/实体批量任务
  exportTask (params) {
    return axiosRequest.post('/task/exportTask', params, {responseType: 'arraybuffer'})
  },
  // 个体/实体批量上传
  insertTask (params) {
    let config = {
      // 一定要定义头
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return axiosRequest.post('/task/insertTask', params, config)
  },
  // 查询已上传任务表格解析的数据
  uploadTask (params) {
    return axiosRequest.post('/task/upload', params)
  },
  // 查询已上传的任务
  insertTask (params) {
    return axiosRequest.post('/task/insertTask', params)
  },
  // 查询命中总条数
  hitTaskNum (params) {
    return axiosRequest.post('/task/hitTaskNum', params)
  },
  // 查询命中列表
  hitTask (params) {
    return axiosRequest.post('/task/hitTask', params)
  },
  // 查询未命中总条数
  unHitTaskNum (params) {
    return axiosRequest.post('/task/unHitTaskNum', params)
  },
  // 查询未命中列表
  unHitTask (params) {
    return axiosRequest.post('/task/unHitTask', params)
  },
  // 下载excel模板
  downloadTemp (params) {
    return axiosRequest.post('/task/download_template', params, {responseType: 'arraybuffer'})
  },
  // 查询当前用户是否有复核权限
  valViewAuth (params) {
    return axiosRequest.post('/task/valViewAuth', params)
  },
  // 通过uid查询用户详情
  worldcheckByuid (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid', params)
  },
  // 复核接口
  reView (params) {
    return axiosRequest.post('/task/reView', params)
  },

  // 登录-获取用户权限
  checkJurisdiction (params) {
    return axiosRequest.get('login/checkJurisdiction?' + params)
  },
  // 登录-获取手机验证码
  getPhoneCode (params) {
    return axiosRequest.post('login/smsSend', params)
  },
  // 登录-用户登录
  login (params) {
    return axiosRequest.post('login/smsLogin', params)
  },
  // 账号密码登陆
  loginByPassword (params) {
    return axiosRequest.post('/login/password', params)
  },
  // 用户注册
  register (params) {
    return axiosRequest.post('/login/register', params)
  },
  // 获取图形验证码
  captcha () {
    return axiosRequest.get('/login/captcha.jpg?d=' + new Date().getTime())
  },
  // 获取短信验证码
  smsSendAny (params) {
    return axiosRequest.post('/login/smsSendAny', params)
  },
  // 重置密码
  resetPassword (params) {
    return axiosRequest.post('/login/resetPassword', params)
  },
  // 获取区号
  areas () {
    return axiosRequest.get('/login/areas')
  },
  // 获取证件类型
  getIdentification () {
    return axiosRequest.get('/advsearch/worldcheck/getIdentification')
  },
  // 企业名称模糊查询
  fsearchCompany (params) {
    return axiosRequest.post('/login/company/fsearch', params)
  },

  // 退出登录
  signOut (params) {
    return axiosRequest.post('login/logout', params)
  },

  // 大陆企业
  // 大陆企业-模糊查询
  fuzzySearch (params) {
    return axiosRequest.post('query/fuzzySearch', params)
  },
  // 大陆企业-企业信息头部
  getCommonHead (params) {
    return axiosRequest.post('stockdetail/getCommonHead', params)
  },
  // 大陆企业-头部更新
  updateTotalInfo (params) {
    return axiosRequest.post('stockdetail/updateMainInfo', params)
  },
  // 大陆企业-企业监控
  monitorEnterprise (params) {
    return axiosRequest.post('personalCenter/enterpriseMonitorApply', params)
  },
  // 大陆企业-基本信息
  getStockInfo (params) {
    return axiosRequest.post('stockdetail/getStckBaseInfo', params)
  },
  // 大陆企业-知识产权
  getKnowledgeRights (params) {
    return axiosRequest.post('stockdetail/getKnowledgeRights', params)
  },
  // 大陆企业-综合风险
  getRiskInfo (params) {
    return axiosRequest.post('stockdetail/getRiskInfo', params)
  },
  // 大陆企业-综合风险-对外投资or股东风险
  getInvestRisk (params) {
    return axiosRequest.post('stockdetail/getInvestouterRisk', params)
  },
  // 根据裁判文书id查文书详情
  getJudgeDetailById (params) {
    return axiosRequest.post('/stockdetail/getRiskInfoDetail', params)
  },
  // 大陆企业-财务报表-获取财务数据
  getFinancialData (params) {
    return axiosRequest.post('stockdetail/get_financial_report', params)
  },
  // 大陆企业-财务报表-订阅财报
  subscibeReport (params) {
    return axiosRequest.post('stockdetail/unlisted_subscribe', params)
  },
  // 大陆企业-财务报表-更新
  updataFinancial (params) {
    return axiosRequest.post('stockdetail/update_financial_report', params)
  },
  // 大陆企业-舆情-获取舆情
  searchOpinion (params) {
    return axiosRequest.post('stockdetail/getCompanyOpinion', params)
  },
  // 大陆企业-舆情-获取关键事件
  getKeyEvents (params) {
    return axiosRequest.post('stockdetail/getFactorIds', params)
  },
  // 大陆企业-舆情-收藏
  addOpinionCollect (params) {
    return axiosRequest.post(
      'personalCenter/addCompanyOpinionFavorites',
      params
    )
  },
  // 大陆企业-舆情-取消收藏
  delOpinionCollect (params) {
    return axiosRequest.post(
      'personalCenter/deleteCompanyOpinionFavorites',
      params
    )
  },
  // 股权穿透部分包括境内外
  // 股权穿透树
  equityTree (params, url) {
    // return axiosRequest.post('query/getEquityPenetrationTree', params) 境内
    // return axiosRequest.post('foreign/stock/getStockTreeForeigh', params) 境外
    return axiosRequest.post(url, params)
  },
  // 股权穿透表格
  equityFrom (params, url) {
    // return axiosRequest.post('query/getJsmindTable', params)
    // return axiosRequest.post('foreign/stock/getStockForeignTable', params)
    return axiosRequest.post(url, params)
  },
  // 股权穿透表格导出
  exportEquityTable (params) {
    return axiosRequest.post('query/getJsmindTable', params)
  },
  // 疑似受益所有人
  getSuspectMap (params, url) {
    // return axiosRequest.post('query/getBeneficiaryMap', params)
    // return axiosRequest.post('foreign/stock/getBeneficiaryMapForeign', params)
    return axiosRequest.post(url, params)
  },
  // 疑似高风险干系人
  getHighDanger (params, url) {
    // return axiosRequest.post('stock/getHighDangerPerson', params)
    // return axiosRequest.post('foreign/stock/getHignDangerPersonForeign', params)
    return axiosRequest.post(url, params)
  },
  // 控制路径
  getControlPath (params, url) {
    // return axiosRequest.post('query/getPathOfBeneficiaryMapByIdOrName', params)
    // return axiosRequest.post('foreign/stock/getPathAndBaseInfo', params)
    return axiosRequest.post(url, params)
  },

  // 图谱
  // 企业关联人
  getBusiAssoInvest (params) {
    return axiosRequest.post('advsearch/associate/investouter', params)
  },
  // 企业关联人-更新
  updateBusiAssoInvest (params) {
    return axiosRequest.post('advsearch/associate/updateAssoInvest', params)
  },
  // 对外投资
  getBusiInvestOut (params) {
    return axiosRequest.post('advsearch/invest/investouter', params)
  },
  // 对外投资-更新
  updateBusiInvestOut (params) {
    return axiosRequest.post('advsearch/invest/updateInvestouter', params)
  },
  // 自然人投资
  getNaturalInvest (params) {
    return axiosRequest.post('advsearch/natural/investouter', params)
  },
  // 自然人投资-更新
  updateNaturalInvest (params) {
    return axiosRequest.post('advsearch/natural/updateNaturalInvest', params)
  },

  // 境外企业
  // 获取境外企业国家列表
  getAbroadCountryList (params) {
    return axiosRequest.post('foreign/getCountryList', params)
  },
  // 模糊查询
  abroadFuzzySearch (params) {
    return axiosRequest.post('foreign/fsearch/fsearchForeign', params)
  },
  // 头部
  abroadCommonHead (params) {
    return axiosRequest.post('foreign/stock/getCommonHeadForeign', params)
  },
  // 基本信息
  abroadStockInfo (params) {
    return axiosRequest.post('foreign/stock/getStockBaseForeigh', params)
  },
  // 更新
  updateAbroadTotalInfo (params) {
    return axiosRequest.post('foreign/stock/updateStockBaseForeigh', params)
  },

  // 黑名单
  // 模糊查询
  wcFuzzySearch (params) {
    return axiosRequest.post('advsearch/worldcheck/blacklist', params)
  },
  // 信息页头部
  wcCommonHead (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid_commonHead', params)
  },
  // 头部-更新
  wcUpdate (params) {
    return axiosRequest.post('advsearch/worldcheck/updateBlacklist', params)
  },
  // 基本信息
  wcBaseInfo (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid_baseInfo', params)
  },
  // 地址图谱
  wcAddressMap (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid_AddressMap', params)
  },
  // 更多信息
  wcMoreInfo (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid_moreInfo', params)
  },
  // 风险关键字
  wcKeyWords (params) {
    return axiosRequest.post('advsearch/worldcheck/getKeyWords', params)
  },
  // 关联关系
  wcAssoInfo (params) {
    return axiosRequest.post('advsearch/worldcheck/getAssoInfo', params)
  },
  // 关联图谱
  wcAssoMap (params) {
    return axiosRequest.post('advsearch/worldcheck/getAssoMap', params)
  },

  // 高级筛查
  // 国家列表
  getAdvanceCountry (params) {
    return axiosRequest.post('advsearch/worldcheck/getCountry', params)
  },

  // 个人中心
  // 企业监控列表数量
  frimMonitorNum (params) {
    return axiosRequest.post(
      'personalCenter/enterpriseAlreadyMonitorNum',
      params
    )
  },
  // 企业监控列表
  firmMonitorList (params) {
    return axiosRequest.post('personalCenter/enterpriseAlreadyMonitor', params)
  },
  // 企业监控详情数量
  frimMonitorDetailNum (params) {
    return axiosRequest.post(
      'personalCenter/enterpriseMonitorQueryNum',
      params
    )
  },
  // 企业监控详情
  frimMonitorDetail (params) {
    return axiosRequest.post('personalCenter/enterpriseMonitorQuery', params)
  },
  // 变更监控频率
  changeFirmMonitorFreq (params) {
    return axiosRequest.post(
      'personalCenter/updateEnterpriseMonitorFreq',
      params
    )
  },
  // 企业监控续期
  firmMonitorRenewal (params) {
    return axiosRequest.post('personalCenter/EnterpriseMonitorRenewal', params)
  },
  // 个人监控数量
  personMonitorNum (params) {
    return axiosRequest.post('personalCenter/personalAlreadyMonitorNum', params
    )
  },
  // 个人监控列表
  personMonitorList (params) {
    return axiosRequest.post('personalCenter/personalAlreadyMonitor', params)
  },
  // 添加企业关联人监控
  monitorPerson (params) {
    return axiosRequest.post('personalCenter/personalMonitorApply', params)
  },
  // 变更个人监控频率
  changePersonMonitorFreq (params) {
    return axiosRequest.post(
      'personalCenter/updatePersonalMonitorFreq',
      params
    )
  },
  // 个人监控续期
  personMonitorRenewal (params) {
    return axiosRequest.post(
      'personalCenter/updatePersonalMonitorFreq',
      params
    )
  },
  // 个人监控详情数量
  personMonitorDetailNum (params) {
    return axiosRequest.post('personalCenter/personalMonitorQueryNum', params)
  },
  // 个人监控详情列表
  personMonitorDetail (params) {
    return axiosRequest.post('personalCenter/personalMonitorQuery', params)
  },
  // 人工核对数量
  getArtificialNum (params) {
    return axiosRequest.post(
      'personalCenter/worldCheckMonitorQueryNum',
      params
    )
  },
  // 人工核对数据
  getArtificialList (params) {
    return axiosRequest.post('personalCenter/worldCheckMonitorQuery', params)
  },
  // 更改人工核对状态
  modifyCheckStatus (params) {
    return axiosRequest.post(
      'personalCenter/worldCheck/modiftCheckStatus',
      params
    )
  },
  // 获取监控财报的企业列表
  getFinancialList (params) {
    return axiosRequest.post('personalCenter/getFinancialCompany', params)
  },
  // 添加监控财报的企业
  addFinancialMonitor (params) {
    return axiosRequest.post('stockdetail/apply_financial_report', params)
  },
  // 获取收藏舆情列表
  opinionCollectList (params) {
    return axiosRequest.post(
      'personalCenter/getCompanyOpinionFavorites',
      params
    )
  },

  // 查询当前上市企业是否有资本系
  queryBelongCaptical (params) {
    return axiosRequest.get(`${window.LOCAL_CONFIG.CAPTICAL_SRC}${params}`)
  },

  // 获取今日更新记录
  updatedToday (params) {
    return axiosRequest.post('/listManagement/ubs_today_update', params)
  },
  // 获取本月更新记录
  updatedThisMonth (params) {
    return axiosRequest.post('/listManagement/ubs_month_update', params)
  },
  // 获取累计更新记录
  updatedTotal (params) {
    return axiosRequest.post('/listManagement/ubs_cumulative_update', params)
  },
  // 获取名单数据加载列表
  listManagement (params) {
    return axiosRequest.post('/listManagement/ubs_update_list', params)
  },

  // 获取黑名单查询新闻列表
  getNewsInfo (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid_external_sources', params)
  },
  // 标记修改
  modifyUrlStatus (params) {
    return axiosRequest.post('/task/query_worldcheck_byuid_update_url_status', params)
  },

  // 查询有无权限显示名单管理页面
  getToken () {
    return axiosRequest.get('/listManagement/getToken')
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js